module.exports = __webpack_public_path__ + "static/media/valora.246ad3ed.jpg";